import Layout from "@/layout"

const allRoutes = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect/index"),
      },
    ],
  },

  {
    path: "/login",
    component: () => import("@/views/Login"),
    hidden: true,
  },
  {
    path: "/",
    component: Layout,
    redirect: "/dashborad",
    children: [
      {
        path: "dashborad",
        name: "Dashborad",
        component: () => import("@/views/Home.vue"),
        meta: { title: "首页", icon: "el-icon-s-home" },
      },
    ],
  },
  {
    path: "/profile",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "",
        name: "Profile",
        component: () => import("@/views/Profile"),
        meta: { title: "个人设置" },
      },
    ],
  },
  {
    path: "/business",
    name: "Business",
    component: Layout,
    meta: { title: "业务管理", icon: "el-icon-s-order" },
    redirect: "noRedirect",
    alwaysShow: true,
    children: [
      {
        path: "whole-vehicle",
        name: "wholeVehicle",
        component: () => import("@/views/BusinessManage/WholeVehicle/index.vue"),
        meta: { title: "整车保管理" },
        redirect: "noRedirect",
        alwaysShow: true,
        children: [
          {
            path: "list",
            name: "wholeVehicleList",
            component: () => import("@/views/BusinessManage/WholeVehicle/List.vue"),
            meta: { title: "整车保" },
          },
          {
            path: "print-pending",
            name: "wholeVehiclePrintPending",
            component: () => import("@/views/BusinessManage/WholeVehicle/PrintPending.vue"),
            meta: { title: "待处理的打印申请-整车保" },
          },
          {
            path: "print-processed",
            name: "wholeVehiclePrintProcessed",
            component: () => import("@/views/BusinessManage/WholeVehicle/PrintProcessed.vue"),
            meta: { title: "已处理的打印申请-整车保" },
          },
        ],
      },
      {
        path: "employee-insurance",
        name: "employeeInsurance",
        component: () => import("@/views/BusinessManage/EmployeeInsurance/index.vue"),
        meta: { title: "雇主险管理" },
        redirect: "noRedirect",
        alwaysShow: true,
        children: [
          {
            path: "list",
            name: "employeeInsuranceList",
            component: () => import("@/views/BusinessManage/EmployeeInsurance/List.vue"),
            meta: { title: "雇主险订单管理" },
          },
          {
            path: "history",
            name: "employeeInsuranceHistory",
            component: () => import("@/views/BusinessManage/EmployeeInsurance/History.vue"),
            meta: { title: "加人换人管理" },
          },
          {
            path: "disable",
            name: "employeeInsuranceDisable",
            component: () => import("@/views/BusinessManage/EmployeeInsurance/Disable.vue"),
            meta: { title: "出险员工管理" },
          },
          {
            path: "employee-lock",
            name: "employeeInsuranceLock",
            component: () => import("@/views/BusinessManage/EmployeeInsurance/EmployeeLock.vue"),
            meta: { title: "出险锁定" },
          },
          {
            path: "message-list",
            name: "employeeInsuranceMessageList",
            component: () => import("@/views/BusinessManage/EmployeeInsurance/MessageList.vue"),
            meta: { title: "员工信息库" },
          },
          {
            path: "scheme-list",
            name: "employeeInsuranceSchemeList",
            component: () => import("@/views/EmployerInsuranceScheme"),
            meta: { title: "方案管理" },
          },
        ],
      },
      {
        path: "no-car-carrier",
        name: "noCarCarrier",
        component: () => import("@/views/BusinessManage/NoCarCarrier/index.vue"),
        meta: { title: "无车承运人管理" },
        redirect: "noRedirect",
        alwaysShow: true,
        children: [
          {
            path: "pingan-trunk-insurance",
            name: "noCarCarrierPingAnTrunkInsurance",
            component: () => import("@/views/BusinessManage/NoCarCarrier/PingAnTrunkInsurance.vue"),
            meta: { title: "平安干线保" },
          },
          {
            path: "pingan-trunk-big-policy-entry",
            name: "noCarCarrierPingAnTrunkBigPolicyEntry",
            component: () => import("@/views/BusinessManage/NoCarCarrier/PingAnTrunkBigPolicyEntry.vue"),
            meta: { title: "平安干线保-大保单录入" },
          },
        ],
      },
      {
        path: "single-ticket-cargo",
        name: "singleTicketCargo",
        component: () => import("@/views/BusinessManage/SingleTicketCargo/index.vue"),
        meta: { title: "单票货运险" },
        redirect: "noRedirect",
        alwaysShow: true,
        children: [
          {
            path: "order-list",
            name: "singleTicketCargoOrderList",
            component: () => import("@/views/BusinessManage/SingleTicketCargo/OrderList.vue"),
            meta: { title: "订单列表" },
          },
        ],
      },
      {
        path: "appointment-freight",
        name: "appointmentFreight",
        component: () => import("@/views/BusinessManage/AppointmentFreight/index.vue"),
        meta: { title: "预约货运险管理" },
        redirect: "noRedirect",
        alwaysShow: true,
        children: [
          {
            path: "all-orders",
            name: "appointmentFreightAllOrders",
            component: () => import("@/views/BusinessManage/AppointmentFreight/AllOrders.vue"),
            meta: { title: "预约货运险全部订单" },
          },
          {
            path: "pricing-scheme",
            name: "appointmentFreightPricingScheme",
            component: () => import("@/views/BusinessManage/AppointmentFreight/PricingScheme.vue"),
            meta: { title: "预约货运险价格方案" },
          },
        ],
      },
      {
        path: "offline-business-order",
        name: "offlineBusinessOrder",
        component: () => import("@/views/BusinessManage/OfflineBusinessOrder/index.vue"),
        meta: { title: "年保订单管理" },
        redirect: "noRedirect",
        alwaysShow: true,
        children: [
          {
            path: "list",
            name: "offlineBusinessOrderList",
            component: () => import("@/views/BusinessManage/OfflineBusinessOrder/OrderList.vue"),
            meta: { title: "年保订单管理" },
          },
        ],
      },
      {
        path: "underwrite-order",
        name: "underwriteOrder",
        component: () => import("@/views/BusinessManage/UnderwriteOrder/index.vue"),
        meta: { title: "年保审核管理" },
        redirect: "noRedirect",
        alwaysShow: true,
        children: [
          {
            path: "list",
            name: "underwriteOrderList",
            component: () => import("@/views/BusinessManage/UnderwriteOrder/OrderList.vue"),
            meta: { title: "货险年单-核保订单列表" },
          },
        ],
      },
      {
        path: "claims-management",
        name: "claimsManagement",
        component: () => import("@/views/BusinessManage/ClaimsManagement/index.vue"),
        meta: { title: "理赔管理" },
        redirect: "noRedirect",
        alwaysShow: true,
        children: [
          {
            path: "cargo-claims",
            name: "cargoClaimsManagement",
            component: () => import("@/views/BusinessManage/ClaimsManagement/CargoClaims.vue"),
            meta: { title: "货运险理赔管理" },
          },
          {
            path: "employer-claims",
            name: "employerClaimsManagement",
            component: () => import("@/views/BusinessManage/ClaimsManagement/EmployerClaims.vue"),
            meta: { title: "雇主险理赔管理" },
          },
          {
            path: "accident-reasons",
            name: "claimAccidentReasons",
            component: () => import("@/views/BusinessManage/ClaimsManagement/AccidentReasons.vue"),
            meta: { title: "事故原因" },
          },
          {
            path: "accident-reasons/level-two",
            name: "claimAccidentReasonLevelTwo",
            component: () => import("@/views/BusinessManage/ClaimsManagement/ReasonLevelTwo.vue"),
            hidden: true,
            meta: { title: "事故原因二级", permission: "claimAccidentReasons" },
          },
          {
            path: "accident-reasons/level-three",
            name: "claimAccidentReasonLevelThree",
            component: () => import("@/views/BusinessManage/ClaimsManagement/ReasonLevelThree.vue"),
            hidden: true,
            meta: { title: "事故原因三级", permission: "claimAccidentReasons" },
          },
          {
            path: "cargo-types",
            name: "claimCargoTypes",
            component: () => import("@/views/BusinessManage/ClaimsManagement/CargoTypes.vue"),
            meta: { title: "货物类型管理" },
          },
          {
            path: "case-qualities",
            name: "claimCaseQualities",
            component: () => import("@/views/BusinessManage/ClaimsManagement/CaseQualities.vue"),
            meta: { title: "案件定性管理" },
          },
        ],
      },
      {
        path: "universal-order",
        name: "universalOrder",
        component: () => import("@/views/BusinessManage/UniversalOrder/index.vue"),
        meta: { title: "通用订单管理" },
        redirect: "noRedirect",
        alwaysShow: true,
        children: [
          {
            path: "list",
            name: "universalOrderList",
            component: () => import("@/views/BusinessManage/UniversalOrder/OrderList.vue"),
            meta: { title: "通用订单列表" },
          },
        ],
      },
    ],
  },
  {
    path: "/product",
    name: "Product",
    component: Layout,
    meta: { title: "产品管理", icon: "el-icon-goods" },
    redirect: "noRedirect",
    alwaysShow: true,
    children: [
      {
        path: "basicConfig",
        name: "basicConfig",
        component: () => import("@/views/ProductManage/BasicConfig"),
        meta: { title: "基础配置" },
      },
      {
        path: "customConfig",
        name: "customConfig",
        component: () => import("@/views/ProductManage/CustomConfig"),
        meta: { title: "自定义配置" },
      },
      {
        path: "preApprovalConfig",
        name: "preApprovalConfig",
        component: () => import("@/views/ProductManage/PreApprovalConfig"),
        meta: { title: "预核保配置" },
      },
      {
        path: "schemeConfig",
        name: "schemeConfig",
        component: () => import("@/views/ProductManage/SchemeConfig"),
        meta: { title: "方案配置" },
      },
      {
        path: "protocolConfig",
        name: "protocolConfig",
        component: () => import("@/views/ProductManage/ProtocolConfig"),
        meta: { title: "条约管理" },
      },
      {
        path: "questionConfig",
        name: "questionConfig",
        component: () => import("@/views/ProductManage/QuestionConfig"),
        meta: { title: "问答管理" },
      },
      {
        path: "insuranceCompanyConfig",
        name: "insuranceCompanyConfig",
        component: () => import("@/views/ProductManage/InsuranceCompanyConfig"),
        meta: { title: "保险公司管理" },
      },
      {
        path: "clauseConfig",
        name: "clauseConfig",
        component: () => import("@/views/ProductManage/ClauseConfig"),
        meta: { title: "保险条款管理" },
      },
    ],
  },
  {
    path: "/custom-frontend",
    name: "CustomFrontend",
    component: Layout,
    meta: { title: "定制前端管理", icon: "el-icon-monitor" },
    redirect: "noRedirect",
    alwaysShow: true,
    children: [
      {
        path: "app-list",
        name: "customFrontendAppList",
        component: () => import("@/views/CustomFrontend/AppList"),
        meta: { title: "基本信息" },
      },
      {
        path: "app-setting",
        name: "customFrontendAppSetting",
        component: () => import("@/views/CustomFrontend/AppSetting"),
        meta: { title: "定制配置" },
      },
    ],
  },
  {
    path: "/member",
    name: "Member",
    component: Layout,
    meta: { title: "会员管理", icon: "el-icon-user" },
    redirect: "noRedirect",
    alwaysShow: true,
    children: [
      {
        path: "list",
        name: "memberList",
        component: () => import("@/views/MemberManage"),
        meta: { title: "会员列表" },
      },
      {
        path: "appointment-freight-user",
        name: "appointmentFreightUser",
        component: () => import("@/views/MemberManage/AppointmentFreightUser.vue"),
        meta: { title: "预约货运险用户" },
      },
      {
        path: "single-ticket-user",
        name: "singleTicketUser",
        component: () => import("@/views/MemberManage/SingleTicketUser.vue"),
        meta: { title: "单票用户" },
      },
      {
        path: "pingan-trunk-user",
        name: "pingAnTrunkUser",
        component: () => import("@/views/MemberManage/PingAnTrunkUser.vue"),
        meta: { title: "平安干线保用户" },
      },
      {
        path: "donghai-special-user",
        name: "dongHaiSpecialUser",
        component: () => import("@/views/MemberManage/DongHaiSpecialUser.vue"),
        meta: { title: "东海专线保用户" },
      },
      {
        path: "employee-user",
        name: "employeeUser",
        component: () => import("@/views/MemberManage/EmployeeUser.vue"),
        meta: { title: "员工保用户" },
      },
      {
        path: "shop-user",
        name: "shopUser",
        component: () => import("@/views/MemberManage/ShopUser.vue"),
        meta: { title: "商铺保用户" },
      },
      // {
      //   path: "dadi-trunk-user",
      //   name: "daDiTrunkUser",
      //   component: () => import("@/views/MemberManage/DaDiTrunkUser.vue"),
      //   meta: { title: "大地干线保用户", },
      // },
      {
        path: "no-car-carrier-user",
        name: "noCarCarrierUser",
        component: () => import("@/views/MemberManage/NoCarCarrierUser.vue"),
        meta: { title: "无车承运人用户" },
      },
      {
        path: "insurance-information",
        name: "insuranceInformationManagement",
        component: () => import("@/views/MemberManage/InsuranceInformation.vue"),
        meta: { title: "投保信息管理" },
      },
    ],
  },
  {
    path: "/channel",
    name: "Channel",
    component: Layout,
    meta: { title: "渠道管理", icon: "el-icon-connection" },
    redirect: "noRedirect",
    alwaysShow: true,
    children: [
      {
        path: "list",
        name: "channelList",
        component: () => import("@/views/ChannelManage/ChannelList.vue"),
        meta: { title: "渠道列表" },
      },
      {
        path: "api-account",
        name: "apiAccount",
        component: () => import("@/views/ChannelManage/ApiAccount.vue"),
        meta: { title: "API对接账号" },
      },
      {
        path: "note-list",
        name: "channelNoteList",
        component: () => import("@/views/ChannelManage/ChannelNoteList.vue"),
        meta: { title: "渠道备注信息", permission: "channelList" },
        hidden: true,
      },
    ],
  },
  {
    path: "/statistics",
    name: "Statistics",
    component: Layout,
    meta: { title: "统计管理", icon: "el-icon-s-data" },
    redirect: "noRedirect",
    alwaysShow: true,
    children: [
      {
        path: "appointment-freight-stats",
        name: "appointmentFreightStats",
        component: () => import("@/views/StatisticsManage/AppointmentFreight/index"),
        meta: { title: "预约货运险统计" },
        redirect: "noRedirect",
        alwaysShow: true,
        children: [
          {
            path: "deposit",
            name: "appointmentFreightDepositStats",
            component: () => import("@/views/StatisticsManage/AppointmentFreight/DepositStats"),
            meta: { title: "预约货运万能充值统计" },
          },
          {
            path: "insurance",
            name: "appointmentFreightInsuranceStats",
            component: () => import("@/views/StatisticsManage/AppointmentFreight/InsuranceStats"),
            meta: { title: "预约货运万能投保统计" },
          },
        ],
      },
      {
        path: "single-ticket-stats",
        name: "singleTicketStats",
        component: () => import("@/views/StatisticsManage/SingleTicket/index"),
        meta: { title: "单票货运险统计" },
        redirect: "noRedirect",
        alwaysShow: true,
        children: [
          {
            path: "deposit",
            name: "singleTicketDepositStats",
            component: () => import("@/views/StatisticsManage/SingleTicket/DepositStats"),
            meta: { title: "单票货运险充值统计" },
          },
          {
            path: "insurance",
            name: "singleTicketInsuranceStats",
            component: () => import("@/views/StatisticsManage/SingleTicket/InsuranceStats"),
            meta: { title: "单票货运险投保统计" },
          },
        ],
      },
      {
        path: "notification",
        name: "notificationManagement",
        component: () => import("@/views/StatisticsManage/Notification/index"),
        meta: { title: "通知管理" },
        redirect: "noRedirect",
        alwaysShow: true,
        children: [
          {
            path: "sms-records",
            name: "smsRecords",
            component: () =>
              import("@/views/StatisticsManage/Notification/SmsRecords"),
            meta: { title: "短信记录" },
          },
          {
            path: "email-records",
            name: "emailRecords",
            component: () =>
              import("@/views/StatisticsManage/Notification/EmailRecords"),
            meta: { title: "邮件记录" },
          },
        ],
      },
    ],
  },
  {
    path: "/admin",
    name: "Admin",
    component: Layout,
    meta: { title: "管理员管理", icon: "el-icon-user-solid" },
    redirect: "noRedirect",
    alwaysShow: true,
    children: [
      {
        path: "role-manage",
        name: "roleManage",
        component: () => import("@/views/AdminManage/RoleManage.vue"),
        meta: { title: "角色管理" },
      },
      {
        path: "staff-manage",
        name: "staffManage",
        component: () => import("@/views/AdminManage/StaffManage.vue"),
        meta: { title: "员工管理" },
      },
      {
        path: "claim-distribution",
        name: "claimDistribution",
        component: () => import("@/views/AdminManage/ClaimDistribution.vue"),
        meta: { title: "产品理赔分配", permission: "roleManage" },
        hidden: true,
      },
      {
        path: "menu-view",
        name: "menuView",
        component: () => import("@/views/AdminManage/MenuView.vue"),
        meta: { title: "查看可用菜单", permission: "roleManage" },
        hidden: true,
      },
    ],
  },
]

const constantRoutePaths = ["/redirect", "/login", "/", "/profile"]

export const constantRoutes = allRoutes.filter(route =>
  constantRoutePaths.includes(route.path)
)

export const asyncRoutes = allRoutes.filter(
  route => !constantRoutePaths.includes(route.path)
)

// 兼容项目中原有的导出名称，实际权限统一由 asyncRoutes 动态生成。
export const hasAccessRoutes = asyncRoutes
export const enterpriseRoutes = asyncRoutes

export default [...constantRoutes, ...asyncRoutes]
